import {FormsList, EntriesList, EntryDetails} from "./Tabs/stripeEntriesTab";

export default function App() {
  const params = new URLSearchParams(window.location.search);

  const formId = params.get("cf7spay_formid");
  const entryId = params.get("cf7spay_entryid");

  if (formId && entryId) {
    return <EntryDetails formId={formId} entryId={entryId} />;
  }

  if (formId) {
    return <EntriesList formId={formId} />;
  }

  return <FormsList />;
}